import { API_ENDPOINTS } from '@/api/apiEndpoints';
import { axiosClient } from '@/api/axiosClient';
import type { DashboardStats } from '@/models';

export interface ReportData {
  callTrends: { date: string; calls: number; confirmed: number }[];
  agentProductivity: { agent: string; calls: number; confirmations: number }[];
  dispositionSummary: { label: string; value: number; percent: number; color: string }[];
  resolutionTime: { date: string; avgMinutes: number }[];
}

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const { data } = await axiosClient.get<{ status: number; message: string | null; data: DashboardStats }>(API_ENDPOINTS.dashboard.stats);
    return data.data;
  },

  async getReports(): Promise<ReportData> {
    const { data } = await axiosClient.get<{ status: number; message: string | null; data: ReportData }>(API_ENDPOINTS.dashboard.reports);
    return data.data;
  },
};
